export default {
  component: () => import('./page.vue'),
  path: '/intro/:sensorType(22|18|resp_rate|score)',
  name: 'intro',
  props: true,
  meta: {
    title: '指标说明',
  },
};
